<template>
  <div>
    <a-modal id='handitem_v' v-model="visible" width='22.5rem' on-ok="handleOk1" @cancel="handleCancel(0)"
      :footer="null"
      :keyboard='false' :maskClosable='false' :dialog-style="{ top: '25vh' }">
      <div class='mark-file'>
        <div style="width: 20.5rem;font-size: 18px;color: #0C8B97;">

        </div>
      </div>
      <div solt='title' style="position: relative;">
        <!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
      </div>
      <div>
        <!-- <div style="margin-bottom: 1rem;">{{params.text_welcome}}</div> -->
        <!-- <pre class='fonts look_l'>text_body</pre> -->
        <!-- <pre class='fonts look_l'>nitice_text_company</pre> -->
        <!-- <pre class='fonts look_l'>{{params.notice_text_final}}</pre> -->
        <img :src="require('@/image/honggu/Wechat - QR CODE.jpg')" alt="" style="width: 20rem;">
      </div>
      <!-- <button id='mybtn_s' @click='handleCancel'>返回</button> -->
    </a-modal>
  </div>
</template>

<script>
  export default {
    props:['items'],
    data() {
      return {
        visible: true,
        text: 'text',
        activeKey: '',
        params:{}
      }
    },
    mounted() {
      // this.getdate()
    },
    methods: {
      handopen(){
        if(this.params.attachment_url) {window.open(this.params.attachment_url)}
      },
      getdate() {
        this.$ajax({
          method: 'post',
          url: this.$api.getNoticeWithid,
          data:{
           "lan": window.localStorage.guanwanglang,
           "noticeid":this.items.noticeid
          }
        }).then(res => {
          if(res.data.qmiscode ===1000){
            this.params = res.data
          }
        })
      },
      handleCancel() {
        this.$emit('child')
      },
      handleOk() {},
      handleClick(event) {
        // If you don't want click extra trigger collapse, you can prevent this:
        event.stopPropagation();
      },
    }
  }
</script>

<style>
  #handitem_v .ant-modal-close-x {
    /* width: 1rem; */
    /* height: 1rem; */
    font-size: 18px  }

  #handitem_v .ant-modal-content {
    border-radius: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/handitem.vue